import React from "react";
import { SVG, IconProps } from "../SVG";
export const SpotWatch = ({
    spotColor = "#C6F4EC",
    color = "#13126C",
    strokeWidth = "2.2",
    ...props
}: IconProps) => (
    <SVG xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 40 40" {...props}>
        <path
            fill={spotColor}
            d="M9.684 25.862c.66 2.84 1.428 6.446 3.447 7.82 2.042 1.398 5.358.587 7.802-.994 2.445-1.558 4.018-3.865 5.947-5.714 1.93-1.85 4.239-3.22 5.882-5.458 1.62-2.214 2.6-5.274 2.417-8.52-.182-3.245-1.526-6.676-4.177-7.295-2.65-.596-6.587 1.596-9.578 2.47-3.014.873-5.036.427-8.097.164-3.06-.262-7.135-.342-8.21 1.444-1.074 1.762.829 5.39 2.091 8.242 1.24 2.876 1.792 4.977 2.476 7.84Z"
        />
        <path
            stroke={color}
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={strokeWidth}
            d="M20 15v5l2.5 2.5m5.015 6.417-.583 6.383a3.333 3.333 0 0 1-3.333 3.034h-7.217a3.333 3.333 0 0 1-3.334-3.034l-.583-6.383m.017-17.833.583-6.384a3.333 3.333 0 0 1 3.317-3.033h7.25A3.333 3.333 0 0 1 26.965 4.7l.584 6.384m4.116 8.915c0 6.444-5.223 11.667-11.666 11.667-6.444 0-11.667-5.223-11.667-11.667 0-6.443 5.223-11.666 11.667-11.666 6.443 0 11.666 5.223 11.666 11.666Z"
        />
    </SVG>
);
SpotWatch.displayName = "SpotWatch";
